<template>
  <GmapInfoWindow
    :opened="$props.opened"
    :position="$props.position"
    :options="customOptions"
    :z-index="$props.zIndex"
    @domready="domready"
  />
</template>

<script>

export default {
  name: 'InfoWindow',
  inject: ['$mapPromise'],
  props: {
    opened: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    position: {
      type: Object,
      default: () => ({ lat: 0, lng: 0 }),
      twoWay: true,
    },
    zIndex: {
      type: Number,
      default: 0,
      twoWay: true,
    },
    content: {
      type: String,
      required: true,
      default: '',
    },
    classes: {
      type: String,
      default: 'border-01 border-color-ground border-radius color-ink px-3 py-1 bg-color-white',
    },
  },
  computed: {
    customOptions() {
      return {
        pixelOffset: {
          width: 0,
          height: 50,
        },
        ...this.$props.options,
        content: this.customContent,
      };
    },
    customContent() {
      return `
        <div class="Infowindow ${this.$props.classes}">
          ${this.$props.content}
        </div>
      `;
    },
  },
  beforeMount() {
    // If someone of these component attributes does not could be because:
    //
    // 1. Developer does not use the component inside of <GmapMap> component
    // from 'vue2-google-maps' package
    //
    // 2. Developer has not installed the package in Vue
    // like this: Vue.use(VueGoogleMaps, {})
    this.checkComponentInstallation();
  },
  methods: {
    checkComponentInstallation() {
      if (!(this.$gmapApiPromiseLazy && this.$mapPromise)) {
        throw Error('Use InfoWindow inside GmapMap component from \'vue2-google-maps\' package');
      }
    },
    domready() {
      const container = document.querySelector('.Infowindow').offsetParent;
      if (container.nextSibling) {
        container.nextSibling.remove();
      }
      if (container.previousSibling) {
        container.previousSibling.remove();
      }
    },
  },
};

</script>
